import Vue from 'vue';
import Router from 'vue-router';

const el = document.getElementById('prop-base-url');
const base_url = (el && el.getAttribute('data')) || undefined;
if (base_url) {
  process.env.BASE_URL = window.location.origin + base_url;
}

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: base_url,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "hotel-landing" */ '@/layouts/public/TheLayout.vue'),
      children: [
        {
          path: '',
          name: 'hotel-landing',
          component: () => import(/* webpackChunkName: "hotel-landing" */ '@/pages/landing/HotelLanding.vue'),
        },
        {
          path: 'guest-info',
          name: 'guest-info',
          component: () => import(/* webpackChunkName: "hotel-landing" */ '@/pages/landing/PersonalDetails.vue'),
        },
        {
          path: 'legal-info',
          name: 'legal-info',
          component: () => import(/* webpackChunkName: "hotel-landing" */ '@/pages/common/public/CompanyInfo.vue'),
        },
        {
          path: 'privacy-policy',
          name: 'privacy-policy',
          component: () => import(/* webpackChunkName: "hotel-landing" */ '@/pages/common/public/PrivacyPolicy.vue'),
        },
        {
          path: 'payment',
          component: () =>
            import(/* webpackChunkName: "hotel-payment-details" */ '@/pages/landing/payment/Payment.vue'),
          children: [
            {
              path: '',
              name: 'payment-details',
              component: () =>
                import(/* webpackChunkName: "hotel-payment-details" */ '@/pages/landing/payment/PaymentDetails.vue'),
            },
            {
              path: 'success',
              name: 'payment-success',
              component: () =>
                import(/* webpackChunkName: "hotel-payment-success" */ '@/pages/landing/payment/PaymentSuccess.vue'),
            },
            {
              path: 'poa-success',
              name: 'payment-poa-success',
              component: () =>
                import(
                  /* webpackChunkName: "hotel-payment-poa-success" */ '@/pages/landing/payment/PaymentSuccess.vue'
                ),
              meta: { poa: true },
            },
          ],
        },
      ],
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "hotel-landing" */ '@/pages/common/public/NotFound.vue'),
    },
  ],
});

router.afterEach((to, from) => {
  if (to.path === from.path) {
    return;
  }
  let store: any = localStorage.getItem('vuex');
  if (!store) {
    return;
  }
  store = JSON.parse(store);
  if (store!!.landing!!.settings!!.google_ads_tracking!!.google_analytics_id) {
    if (window && typeof (window as any).gtag !== 'undefined') {
      (window as any).gtag('config', store.landing.settings.google_ads_tracking.google_analytics_id, {
        page_title: to.name,
        page_path: base_url + to.path,
      });
    }
  }
});

export default router;
